import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/past-trauma-resurfacing")({
  beforeLoad: () => {
    throw redirect({ to: "/when-past-trauma-resurfaces", replace: true });
  },
});
